
    
<div class="breadcrumb-sec">
    <h5 class="w-50 !mb-0">
       Group Management
    </h5>
    <ol class="breadcrumb m-0">
        <li class="breadcrumb-item inline-block relative">
            <a routerLink="/dashboard" class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
                <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-lg -mt-px text-sky-600 top-1/2 -translate-y-1/2">
                    home
                </i>
                Department
            </a>
        </li>
        <li class="breadcrumb-item">
            Group Management
        </li>
    </ol>
</div>

<div class="grid grid-cols-6 gap-4">
    <div class="col-span-4 col-start-2 ...">
        <form >
            <div>
                <fieldset>
                    <legend>Group Management</legend>
                    <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
                        <div class="md:col-span-2">
                                <mat-form-field appearance="outline">
                                    <mat-label>Group Name</mat-label>
                                    <input matInput type="text">
                                </mat-form-field>
                        </div>
                        <div class="md:col-span-2">
                            <mat-form-field appearance="outline">
                                <mat-label>View Type</mat-label>
                                <mat-select >
                                    <mat-option value="List">List</mat-option>
                                    <mat-option value="Grid">Grid</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        
                        <div class="md:col-span-2" style="margin: -5px 0 0;">
                            <label class="m-0 font-semibold text-base" style="width:10%; padding: 0 5px; color: #0084d1;">Permission </label>
                            <section class="example-section" >
                                <mat-checkbox>Checkbox 1</mat-checkbox>    
                                <mat-checkbox>Checkbox 2</mat-checkbox>     
                                <mat-checkbox>Checkbox 3</mat-checkbox>    
                                <mat-checkbox>Checkbox 4</mat-checkbox>    
                                <mat-checkbox>Checkbox 5</mat-checkbox>                  
                            </section>
                        </div>
                        <div class="md:col-span-2">
                            <mat-slide-toggle  class="pt-3">Active</mat-slide-toggle> 
                        </div> 
                    </div>
                </fieldset>
            </div>
            <div class="flex flex-row justify-center space-x-3 my-4">
                
                <div>
                    <button type="button" class="">
                        <div class="signup-btn flex space-between-3 bg-red-600 text-white border border-red-600">
                            <i class="material-symbols-outlined">
                                arrow_left_alt
                            </i>
                            Go Back
                        </div>
                    </button>
                </div>
                <div>
                    <button type="button"  class="">
                        <div class="signup-btn flex space-between-3 bg-sky-600 text-white border border-sky-600">
                            <i class="material-symbols-outlined">
                                refresh
                            </i>
                            Refresh
                        </div>
                    </button>
                </div>
                <div>
                    <button type="submit"  class="">
                        <div class="signup-btn flex space-between-3 bg-green-700 text-white border border-green-700">
                            <i class="material-symbols-outlined">
                                save
                            </i>
                            Save
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>


